export default __webpack_public_path__ + "static/media/istockphoto-918319088-170667a.6b73d277.jpg";